/* 🤖 this file was generated by svg-to-ts*/
export const icoHome: {
  name: 'home';
  data: string;
} = {
  name: 'home',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.445 2.168L2.891 7.871l-.15.111C2.254 8.401 2 8.952 2 9.535V20l.008.174C2.13 21.236 2.982 22 4 22h5l.117-.007A1 1 0 0010 21v-6h4v6a1 1 0 001 1h5l.174-.008C21.236 21.87 22 21.018 22 20V9.535l-.01-.186c-.077-.638-.396-1.155-.88-1.478l-8.555-5.703a1 1 0 00-1.11 0zM8 20H4l-.002-.058L4 9.535l.05-.036L12 4.202 20 9.535l.002.062L20 20l-.058.003L16 20v-6a1 1 0 00-1-1H9l-.117.007A1 1 0 008 14v6z" fill="#909090"/></svg>`
};
